<div class="wrap" [ngClass]="!hideRank ? 'notHideRank' : ''" [ngStyle]="{ backgroundColor: backgroundColor }">
    <app-promotion-leaderboard-my-rank
            [myInfo]="myInfo"
            [isChase]="isChase"
            [isWsopPrizeCustom]="isWsopPrizeCustom"
            [prizeVisibility]="prizeVisibility"
            [onlyCoin]="onlyCoin"
            [hideSymbol]="hideSymbol"
            [hideCustomSymbol]="hideCustomSymbol"
            [isBountyKOPromotion]="isBountyKOPromotion"
            *ngIf="!hideRank"
    >
    </app-promotion-leaderboard-my-rank>
    <div class="group-area" *ngIf="!hideRank">
        <div class="set-refresh" (click)="refresh($event)"></div>
    </div>
    <div class="list-table" [ngClass]="hideRank && leaderboardTypes.WSOP !== leaderboardType ? 'hideRank' : ''">
        <app-promotion-leaderboard-list-table
                *ngIf="leaderboardTypes.NORMAL === leaderboardType"
                [myInfo]="myInfo" [prizePoolList]="prizePoolList"
                [progress]="progress" [isMaintenance]="isMaintenance"
                [type]="type" [isScrolling]="isScrolling"
                [promotionId]="promotionId" [nickname]="nickname"
                [brandId]="brandId" [siteId]="siteId"
                [rankingList]="rankingList" [countryCodes]="countryCodes"
                [playerLimit]="playerLimit" [prizeVisibility]="prizeVisibility"
                [onlyCoin]="onlyCoin" [hideSymbol]="hideSymbol" [hideCustomSymbol]="hideCustomSymbol"
                [countryCode]="countryCode" [focusFirstPlayer]="focusFirstPlayer" [isBountyKOPromotion]="isBountyKOPromotion"
        ></app-promotion-leaderboard-list-table>
        <app-wsop-nationality-ranking-table
                *ngIf="leaderboardTypes.WSOP === leaderboardType"
                [progress]="progress"
                [isMaintenance]="isMaintenance"
                [isScrolling]="isScrolling"
                [rankingList]="wsopNationalityRankingList"
                [countryCodes]="countryCodes"
                [countryCode]="countryCode"
        ></app-wsop-nationality-ranking-table>
    </div>
</div>
